import { fork, all } from 'redux-saga/effects';
import { watchApiTask } from 'app/sagas';
import { api } from 'app/api';
import * as actions from './networkPanelActions';

export const getNetworkPanelSsoUrlTask = watchApiTask(
  actions.GET_NETWORK_PANEL_SSO_URL,
  api.post,
  '/evaluation-system/generateNetworkPanelSsoUrl.php',
);

export function* sagas() {
  yield all([fork(getNetworkPanelSsoUrlTask)]);
}
